import { useFlag } from '@web/services/feature-flags';
import { PropsWithChildren } from 'react';
import MaintenanceModeComponent from './MaintenanceModeComponent';

const MaintenanceMode = ({ children }: PropsWithChildren<Record<string, unknown>>) => {
  const maintenanceMode = useFlag('MAINTENANCE_SCREEN');

  if (maintenanceMode?.active === true && maintenanceMode?.time) {
    return <MaintenanceModeComponent time={maintenanceMode.time} />;
  } else {
    return <>{children}</>;
  }
};

export default MaintenanceMode;
